// extracted by mini-css-extract-plugin
module.exports = {"main":"BackgroundImage-module--main--3FUPG","overlay":"BackgroundImage-module--overlay--1qyiN"};